import AccessibilityMode from '@maxpreps/shared/constants/accessibilityMode';
import { minutesToSeconds } from '@maxpreps/shared/functions/primitiveHelpers/dateTimeHelpers';
import {
  formatHierarchy,
  formatPageType
} from '@maxpreps/shared/functions/utils/trackingUtils';
import { IPageMetaData } from '@maxpreps/shared/models/metaTypes';
import projectConfig from '../project.meta';
import { ITeamPageConfig } from './../utils/ITeamPageConfig';
import { Page } from './../utils/pages';

const hierarchy = formatHierarchy(projectConfig.projectMetaData.hierarchy, [
  'schedule'
]);

const pageType = formatPageType(hierarchy);

const pageMetaData: IPageMetaData = {
  pageType,
  hierarchy,
  targeting: {
    ptype: pageType
  },
  tracking: `/local/team/schedule.aspx`,
  hasVideoPlayer: true
};

const pageConfig: ITeamPageConfig = {
  page: Page.Schedule,
  navId: 'schedule',
  pageName: 'Schedule',
  adminConfig: {
    isBannerVisible: true
  },
  accessbilityMode: AccessibilityMode.Both,
  pageMetaData,
  jsonLd: { enabled: true, include: ['schedule'] },
  packagedCacheConfig: {
    edgeConfig: {
      maxAge: minutesToSeconds(10)
    }
  }
};

export default pageConfig;
